export async function useFetchSitemapLinks() {
  const locale = useRoute().params.locale as 'de' | 'en'
  const client = useRuntimeConfig().public.client

  const pathsToExlude: Record<'de' | 'en', string[]> = {
    de: [
      'google',
      'qrcode',
      'newsletterabmeldung-erfolgreich',
      'newsletterabmeldung-fehler',
      'newsletteranmeldung-erfolgreich',
      'newsletteranmeldung-fehler',
      'omq-flinkster',
      'registrierung-erfolgreich',
      'registrierung-erfolgreich-bahn-bonus',
    ],
    en: [
      'newslettersubscription-error',
      'newslettersubscription-success',
      'newsletterunsubscription-error',
      'newsletterunsubscription-success',
      'registration-successful',
      'registration-successful-bahn-bonus',
    ],
  }

  const linksToInclude: Record<'de' | 'en', SitemapLink[]> = {
    de:
      client !== 'flinkster'
        ? [
            { title: 'Profil', path: '/de/kundenbereich' },
            { title: 'Login', path: '/de/anmelden' },
            { title: 'Passwort vergessen', path: '/de/passwort-vergessen' },
            { title: 'Kündigen', path: '/de/kuendigen' },
            { title: 'Rad melden', path: '/de/rad-melden' },
          ]
        : [],
    en:
      client !== 'flinkster'
        ? [
            { title: 'Profile', path: '/en/self-service' },
            { title: 'Login', path: '/en/login' },
            { title: 'Forgot password', path: '/en/forgot-password' },
            { title: 'Cancel contract', path: '/en/kuendigen' },
            { title: 'Report a bike', path: '/en/report-a-bike' },
          ]
        : [],
  }
  const { data: page } = await useFetch<SitemapLink[]>('/api/pages', {
    baseURL: useRuntimeConfig().public.cms,
    method: 'GET',
    query: {
      locale: `${locale}`,
      'pagination[page]': 1,
      'pagination[pageSize]': 1000,
    },
    deep: false,
    transform: (response: any) => {
      return response.data
        .filter(
          (page: Page) =>
            page.title &&
            page.path &&
            !pathsToExlude[locale].includes(page.path)
        )
        .map((page: Page) => ({
          title: page.title,
          path: `/${page.locale}/${page.path}`,
        }))
        .concat(linksToInclude[locale])
        .sort((a: SitemapLink, b: SitemapLink) =>
          a.title.localeCompare(b.title)
        )
    },
  })
  return page
}
